<template>
  <div class="container">
    <template v-for="(item,index) in Object.keys(extraObj)">
      <template v-if="item=='phone'">
        <div class="form-block">
          <p class="form-title">*手机号</p>
          <input type="tel" placeholder="请输入手机号" v-model="extra.phone">
        </div>
        <div class="form-block">
          <input type="number" placeholder="请输入验证码" v-model="extra.code">
          <a href="javascript:;" class="form-link" :class="{disabled: time > 0 || !extra.phone}" @click="sendCode">{{btnText}}</a>
        </div>
      </template>
      <template v-else-if="item=='_interest'">
        <div class="form-block">
          <p class="form-title">*是否对"职业规划"感兴趣</p>
          <label class="form-check">
            <input type="radio" v-model="extra._interest" value="不想了解"><span>不想了解</span>
          </label>
          <label class="form-check">
            <input type="radio" v-model="extra._interest" value="有点感兴趣"><span>有点感兴趣</span>
          </label>
          <label class="form-check">
            <input type="radio" v-model="extra._interest" value="非常感兴趣"><span>非常感兴趣</span>
          </label>
        </div>
      </template>
      <template v-else-if="item=='_identity'">
        <div class="form-block">
          <p class="form-title">*身份</p>
          <label class="form-check">
            <input type="radio" v-model="extra._identity" value="在校学生"><span>在校学生</span>
          </label>
          <label class="form-check">
            <input type="radio" v-model="extra._identity" value="已毕业/已就业"><span>已毕业/已就业</span>
          </label>
        </div>
      </template>
      <template v-else-if="item=='_identity3'">
      </template>
      <template v-else-if="item=='_identity2'">
        <div class="form-block">
          <p class="form-title">*身份</p>
          <select v-model="extra._identity2" @change="change_identity2();">
            <option value="-请选择-" selected>-请选择-</option>
            <option value="小学生">小学生</option>
            <option value="初中生">初中生</option>
            <option value="高中生">高中生</option>
            <option value="大学生">大学生</option>
            <option value="研究生">研究生</option>
            <option value="职场人">职场人</option>
          </select>
        </div>

        <div class="form-block" v-show="extra._identity2 == '小学生' " style="padding-left:10%;">
          <label class="form-check" style="width:30%;">
            <input type="radio" v-model="extra._identity3" value="一年级"><span>一年级</span>
          </label>
          <label class="form-check" style="width:30%;">
            <input type="radio" v-model="extra._identity3" value="二年级"><span>二年级</span>
          </label>
          <label class="form-check" style="width:30%;">
            <input type="radio" v-model="extra._identity3" value="三年级"><span>三年级</span>
          </label>
          <label class="form-check" style="width:30%;">
            <input type="radio" v-model="extra._identity3" value="四年级"><span>四年级</span>
          </label>
          <label class="form-check" style="width:30%;">
            <input type="radio" v-model="extra._identity3" value="五年级"><span>五年级</span>
          </label>
          <label class="form-check" style="width:30%;">
            <input type="radio" v-model="extra._identity3" value="六年级"><span>六年级</span>
          </label>
        </div>
        <div class="form-block" v-show="extra._identity2 == '初中生' " style="padding-left:10%;">
          <label class="form-check" style="width:30%;">
            <input type="radio" v-model="extra._identity3" value="初一"><span>初一</span>
          </label>
          <label class="form-check" style="width:30%;">
            <input type="radio" v-model="extra._identity3" value="初二"><span>初二</span>
          </label>
          <label class="form-check" style="width:30%;">
            <input type="radio" v-model="extra._identity3" value="初三"><span>初三</span>
          </label>
        </div>
        <div class="form-block" v-show="extra._identity2 == '高中生' " style="padding-left:10%;">
          <label class="form-check" style="width:30%;">
            <input type="radio" v-model="extra._identity3" value="高一"><span>高一</span>
          </label>
          <label class="form-check" style="width:30%;">
            <input type="radio" v-model="extra._identity3" value="高二"><span>高二</span>
          </label>
          <label class="form-check" style="width:30%;">
            <input type="radio" v-model="extra._identity3" value="高三"><span>高三</span>
          </label>
        </div>

        <div class="form-block" v-show="extra._identity2 == '大学生' " style="padding-left:10%;">
          <label class="form-check" style="width:30%;">
            <input type="radio" v-model="extra._identity3" value="大一"><span>大一</span>
          </label>
          <label class="form-check" style="width:30%;">
            <input type="radio" v-model="extra._identity3" value="大二"><span>大二</span>
          </label>
          <label class="form-check" style="width:30%;">
            <input type="radio" v-model="extra._identity3" value="大三"><span>大三</span>
          </label>
          <label class="form-check" style="width:30%;">
            <input type="radio" v-model="extra._identity3" value="大四"><span>大四</span>
          </label>
          <label class="form-check" style="width:30%;">
            <input type="radio" v-model="extra._identity3" value="大五"><span>大五</span>
          </label>
        </div>

        <div class="form-block" v-show="extra._identity2 == '研究生' " style="padding-left:10%;">
          <label class="form-check" style="width:30%;">
            <input type="radio" v-model="extra._identity3" value="研一"><span>研一</span>
          </label>
          <label class="form-check" style="width:30%;">
            <input type="radio" v-model="extra._identity3" value="研二"><span>研二</span>
          </label>
          <label class="form-check" style="width:30%;">
            <input type="radio" v-model="extra._identity3" value="研三"><span>研三</span>
          </label>
        </div>

        <div class="form-block" v-show="extra._identity2 == '职场人' " style="padding-left:10%;">
          <label class="form-check" style="width:30%;">
            <input type="radio" v-model="extra._identity3" value="0-3年"><span>0-3年</span>
          </label>
          <label class="form-check" style="width:30%;">
            <input type="radio" v-model="extra._identity3" value="4-5年"><span>4-5年</span>
          </label>
          <label class="form-check" style="width:30%;">
            <input type="radio" v-model="extra._identity3" value="6-10年"><span>6-10年</span>
          </label>
          <label class="form-check" style="width:30%;">
            <input type="radio" v-model="extra._identity3" value="10年以上"><span>10年以上</span>
          </label>
        </div>
      </template>

      <template v-else-if="item=='_purpose'">
        <div class="form-block">
          <p class="form-title">*测评目的</p>
          <label class="form-check">
            <input type="radio" v-model="extra._purpose" value="个人需求"><span>个人需求</span>
          </label>
          <label class="form-check">
            <input type="radio" v-model="extra._purpose" value="公司培训"><span>公司培训</span>
          </label>
        </div>
      </template>
      <template v-else-if="item=='_gender'">
        <div class="form-block">
          <p class="form-title">*性别</p>
          <label class="form-check">
            <input type="radio" v-model="extra._gender" value="男"><span>男</span>
          </label>
          <label class="form-check">
            <input type="radio" v-model="extra._gender" value="女"><span>女</span>
          </label>
        </div>
      </template>
      <template v-else-if="item=='_province_city'">
        <div class="form-block">
          <p class="form-title">*所在省市</p>
          <input type="text" placeholder="请选择所在省市" v-model="extra._province_city" readonly @click="showAreaPicker = true">
        </div>
      </template>
      <template v-else-if="item=='name'">
        <div class="form-block">
          <p class="form-title">*{{extraObj[item]}}</p>
          <input type="text" :placeholder="'请输入'+extraObj[item]" v-model="extra[item]">
        </div>
      </template>
      <template v-else>
        <div class="form-block">
          <p class="form-title">{{extraObj[item]}}</p>
          <input type="text" :placeholder="'请输入'+extraObj[item]" v-model="extra[item]">
        </div>
      </template>
    </template>
    <div class="form-block pt50">
      <a href="javascript:;" class="form-btn" :class="{disabled: !canSubmit}" @click="saveUserInfo">提交</a>
    </div>
    <van-popup v-model="showAreaPicker" position="bottom">
      <van-area ref="areas" :area-list="areaList" :columns-num="2" @confirm="onConfirm" @cancel="showAreaPicker = false" />
    </van-popup>
  </div>
</template>

<script>
import { send_sms,check_sms } from "@/api/xuandui_gadgets";
import { submit_mantis } from '@/api/measurement';
import areaList  from '@/utils/area'

export default {
  data() {
    return {
      extra: {
        _identity2: "-请选择-",
        phone: "",
        code: "",
        _interest: "",
        _identity: "",
        _identity3: "",
        _purpose: "",
        _gender: "",
        _province_city: "",
        name: "",
      },
      btnText: '发送验证码',
      time: 0,
      sms_info: {},
      areaList,
      showAreaPicker: false,
    }
  },
  props:['extraObj','query','cid','skip'],
  computed: {
    canSubmit() {
      let fields = Object.keys(this.extraObj);
      if(fields.includes('phone')) {
        fields.push('code');
      }
      // console.log('fields', fields);
      for(let i = 0; i < fields.length; i++) {
        if(!this.extra[fields[i]]) {
          // console.log(fields[i], this.extra[fields[i]]);
          return false;
        }
      }
      return true;
    }
  },
  methods: {
    onConfirm(arr){
      const value = `${arr[0].name}  ${arr[1].name}`;
      // console.log(value);
      this.extra._province_city = value;
      this.showAreaPicker = false;
    },
    saveUserInfo() {
      let fields = Object.keys(this.extraObj);
      let common_fields = ['name', 'phone', '_identity', '_identity2', '_identity3', '_interest', '_gender', '_province_city'];

      // console.log(fields);
      // console.log(this.extra);
      // console.log(this.extra._identity2);
      // console.log(!this.extra._identity2);
      // console.log(this.extra._identity2=="-请选择-");

      // console.log(!this.extra._identity3);

      if(fields.includes('_identity2')) {
        if (!this.extra._identity2 || this.extra._identity2 == "-请选择-") {
          this.$toast('请选择身份');
          return;
        } else {
          if (!this.extra._identity3) {
            this.$toast('请选择身份.');
            return;
          } else {
            if (this.extra._identity2 == "小学生") {
              var _identity3_arr = ["一年级", "二年级", "三年级", "四年级", "五年级", "六年级"];
            }
            if (this.extra._identity2 == "初中生") {
              var _identity3_arr = ["初一", "初二", "初三"];
            }
            if (this.extra._identity2 == "高中生") {
              var _identity3_arr = ["高一", "高二", "高三"];
            }
            if (this.extra._identity2 == "大学生") {
              var _identity3_arr = ["大一", "大二", "大三", "大四", "大五"];
            }
            if (this.extra._identity2 == "研究生") {
              var _identity3_arr = ["研一", "研二", "研三"];
            }
            if (this.extra._identity2 == "职场人") {
              var _identity3_arr = ["0-3年", "4-5年", "6-10年", "10年以上"];
            }
            if (_identity3_arr.indexOf(this.extra._identity3) < 0) {
              this.$toast('请选择身份。');
              return;
            }
          }
        }
      }

      if(fields.includes('name') && !this.extra.name) {
        this.$toast('请输入姓名');
        return;
      }
      if(fields.includes('phone') && !this.extra.phone) {
        this.$toast('请输入手机号');
        return;
      } else if (fields.includes('phone') && !/^1[3-9][0-9]{9}$/.test(this.extra.phone)) {
        this.$toast('手机号码不正确');
        return;
      }

      if(fields.includes('phone') && !this.extra.code) {
        this.$toast('请输入验证码');
        return;
      }

      if(fields.includes('_identity') && !this.extra._identity) {
        this.$toast('请选择身份');
        return;
      }

      if(fields.includes('_purpose') && !this.extra._purpose) {
        this.$toast('请选择测评目的');
        return;
      }

      if(fields.includes('_interest') && !this.extra._interest) {
        this.$toast('请选择是否感兴趣');
        return;
      }

      if(fields.includes('_gender') && !this.extra._gender) {
        this.$toast('请选择性别');
        return;
      }

      if(fields.includes('_province_city') && !this.extra._province_city) {
        this.$toast('请选择所在省市');
        return;
      }

      for(let i = 0; i < fields.length; i++) {
        if(common_fields.includes(fields[i])) {
          continue;
        }
        if(!this.extra[fields[i]]) {
          this.$toast('请输入'+this.extraObj[fields[i]]);
          return;
        }
      }

      if(fields.includes('phone') && !this.sms_info.sms_id) {
        this.$toast('请重新验证');
        return;
      }

      if(fields.includes('phone')) {
        check_sms({sms_id: this.sms_info.sms_id, code: this.extra.code}).then(res=>{
          if(res.error>0) {
            return Promise.reject(res.msg);
          }
          if(this.sms_info.phone != this.extra.phone) {
            return Promise.reject('请重新验证');
          }
          this.submit();
        }).catch(msg=>{
          if(!msg) {
            this.$toast(msg);
          }
        });
      } else {
        this.submit();
      }
    },
    submit() {
      if(this.skip) {
        return this.$emit('saveuserinfo', this.extra);
      }
      this.$emit('saveuserinfo', this.extra);
      // submit_mantis({
      //   cid: this.cid,
      //   lead_sid: this.query.lead_sid,
      //   content: JSON.stringify(this.extra),
      //   order: this.query.order || 0,
      //   sid: this.query.sid,
      // }).then(data=>{
      //   if (data.code == 10002) {
      //     this.$toast(data.msg);
      //     return;
      //   }
      //   this.$emit('saveuserinfo', this.extra);
      // });
    },
    sendCode() {
      if(this.time > 0) {
        return;
      }

      if(!this.extra.phone) {
        this.$toast('请输入手机号');
        return;
      } else if (!/^1[3-9][0-9]{9}$/.test(this.extra.phone)) {
        this.$toast('手机号码不正确');
        return;
      }

      send_sms({mobile: this.extra.phone}).then(res=>{
        if(res.error > 0) {
          if(res.msg) {
            this.$toast(res.msg);
          }
          return;
        }

        this.sms_info.phone = this.extra.phone;
        this.sms_info.sms_id = res.sms_id;

        this.time = 60;
        this.btnText = `${this.time}s`;
        let t = setInterval(()=>{
          if(this.time > 0) {
            this.time--;
            this.btnText = `${this.time}s`;
          } else {
            clearInterval(t);
            this.btnText = '重新发送';
          }
        }, 1000);
      }).catch(msg=>{
        if(!msg) {
          this.$toast(msg);
        }
      });
    }
    ,change_identity2(){
      // this.extra._identity3 = "";
    }
  },
  mounted(){
    document.title = '个人信息提交';
  }
};
</script>

<style lang="scss" scoped>
.form-block {
  padding: 30px 30px 0;
  position: relative;

  &.pt50 {
    padding-top: 100px;
  }

  .form-title {
    padding: 10px 0 0;
    margin: 0 0 16px 0;
    font-size: 28px;
    font-weight: 400;
    color: #606060;
    line-height: 40px;
  }

  .form-link {
    width: 140px;
    height: 40px;
    font-size: 28px;
    font-weight: 600;
    color: #F57F17;
    line-height: 40px;
    text-align: center;
    position: absolute;
    top: 50%;
    right: 60px;
    margin-top: -5px;
    white-space: nowrap;

    &.disabled {
      color: #ccc;
    }
  }

  .form-btn {
    display: inline-block;
    width: 100%;
    height: 100px;
    background: #F57F17;
    border-radius: 50px;
    line-height: 100px;
    text-align: center;
    font-size: 36px;
    font-weight: 600;
    color: #fff;
    letter-spacing: 0.5em;

    &.disabled {
      background-color: #ccc;
    }
  }

  .form-check {
    display: inline-block;
    box-sizing: border-box;
    width: 300px;
    height: 48px;
    line-height: 48px;
    font-size: 32px;
    font-weight: 400;
    color: #333333;
    line-height: 48px;
    position: relative;
    padding-left: 1.5em;

    & > input[type="checkbox"], & > input[type="radio"] {
      display: none;

      & + span:before {
        content: ' ';
        width: 1em;
        height: 1em;
        border-radius: 50%;
        background: #999;
        position: absolute;
        top: 50%;
        left: 0;
        margin-top: -0.5em;
      }

      &:checked + span:before {
        background: #F57F17;
      }

      & + span:after {
        content: ' ';
        width: 0.375em;
        height: 0.15em;
        border: 1PX solid #f5f5f5;/*no*/
        border-top: none;
        border-right: 0;
        position: absolute;
        top: 50%;
        left: 0.5em;
        margin-top: -0.15em;
        transform: translate(-50%) rotate(-45deg);
        transform-origin: center;
      }
    }
  }

  input, select {
    appearance: none;
    -webkit-appearance: none;
  }

  input::placeholder {
    color: #ccc;
  }

  input[type="text"], input[type="tel"], input[type="number"] {
    box-sizing: border-box;
    border: none;
    width: 100%;
    height: 96px;
    background: #fff;
    border-radius: 8px;
    line-height: 96px;
    padding: 0 30px;
    font-size: 28px;
    color: #333;
    outline: none;
  }

  select {
    box-sizing: border-box;
    border: none;
    width: 100%;
    height: 96px;
    background: #fff;
    border-radius: 8px;
    line-height: 96px;
    padding: 0 30px;
    font-size: 28px;
    color: #333;
    outline: none;
  }

}

.container{
  position: fixed;
  width: 100%;
  max-width: 750px;
  left: 50%;
  transform: translateX(-50%);
  top: 0;
  height: 100%;
  background-color: #f5f5f5;
  overflow: auto;
  box-sizing: border-box;
  padding-bottom: 40px;
}
</style>